import React from "react";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import { connect } from "react-redux";
import md5 from "md5";
import { Link } from "react-router-dom";
import Preload from "image-preload";
Preload(["/edge/images/updated_logos/incomplete_icon.svg"]);
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class UpcomingProjectCompletions extends React.Component {
  static contextType = FilterContext;

  state = {
    upcomingProjectCompletions: [],
    filters: "",
  };

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post(
        "api/edge/office/get_upcoming_project_completions",
        BodyAsFormData(filters)
      )
      .then((res) => {
        this.setState({ upcomingProjectCompletions: res.data.slice(0, 3) });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_upcoming_project_completions",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({ upcomingProjectCompletions: res.data.slice(0, 3) });
        });
    }
  }

  render() {
    return (
      <div className="col-lg-4">
        <div className="widget widgetUpcoming">
          <h3>Upcoming Project Completions</h3>
          {this.state.upcomingProjectCompletions.map((row, i) => (
            <div className="customWrapper" key={i}>
              <h5 className="mt-3">
                <Link
                  target="_blank"
                  to={`/office/asset/?filter={"complex":[{"id":"b-${md5(
                    row.complex
                  )}","value":"${row.complex}","label":"${row.complex}"}]}`}
                >
                  {row.complex}
                </Link>
              </h5>
              {row.complex !== row.building && (
                <h5 className="">{row.building}</h5>
              )}
              <h5>Leasable Area: {row.area}</h5>
              <div className="row mt-3 ms-0 me-1">
                <div className="darkBlueBg">
                  <div className="row">
                    <div className="col-lg-4">
                      <img
                        alt="Project Incomplete Icon"
                        src="/edge/images/incomplete_icon.png"
                      />
                    </div>
                    <div className="col-lg-8 upcomingTableFlex">
                      <p className="text-start">Completion Date</p>
                      <h5 className="completionDate">{row.completion_date}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(UpcomingProjectCompletions);
